import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import {
    formataNotaConsorcio,
} from '../../../business-components/Formata/Formata'

import {
    CardGridEstudoHeaderBody,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    SvgImageChaveSetaConsorcio,
} from '../../../business-components/SvgImage/SvgImage'

import {
    pesquisaList,
    pesquisaDescricaoList,
} from '../../../business-rules/List/ListService'

import administradoraConsorcioList from '../../../business-rules/List/Consorcio/administradoraConsorcioList'

import formaAbaterLanceList from '../../../business-rules/List/Consorcio/formaAbaterLanceList'

import {
    processaCalculoConsorcioSimulacaoItem
} from './ConsorcioServiceSimulacaoItem'

import {
    ConsorcioSimulacaoReport,
    ConsorcioSimulacaoReportNumeroValor,
    ConsorcioSimulacaoReportPercValor,
} from './ConsorcioCompSimulacaotemReport'



const ConsorcioFormSimulacaoItemReport = ({ values, item, report }) => {
    
    const linhaInstituicaoFinanceira =
        item.administradoraConsorcio
            ?
                pesquisaList(administradoraConsorcioList(true), item.administradoraConsorcio)
            :
                null

    const SvgConsorcioLogoInstituicaoFinanceira =
        linhaInstituicaoFinanceira && linhaInstituicaoFinanceira.SvgConsorcioLogo
            ?
                linhaInstituicaoFinanceira.SvgConsorcioLogo
            :
                ''
        
    processaCalculoConsorcioSimulacaoItem(values, item, linhaInstituicaoFinanceira)

    return (
        <GridContainer
            className={report ? 'mt--5' : ''}
        >
            <GridItem12>
                <GridContainer
                    className='justify-center'
                >
                    <GridItem12>
                        <GridContainer
                            className='justify-end mt-2 mb-2'
                        >
                            {!item.naoExibirLogo && (
                                <>
                                    {SvgConsorcioLogoInstituicaoFinanceira
                                        ?
                                            <div
                                                //className={'ml--' + linhaInstituicaoFinanceira.svgConsorcioLogoMl}
                                            >
                                                <SvgConsorcioLogoInstituicaoFinanceira/>
                                            </div>
                                        :
                                            <ConsorcioSimulacaoReport
                                                texto={pesquisaDescricaoList(administradoraConsorcioList(true), item.administradoraConsorcio)}
                                            />
                                    }
                                </>
                            )}
                        </GridContainer>

                        <CardGridEstudoHeaderBody
                            title={LABEL.credito}
                        >
                            <GridContainer>
                                <GridItem12>
                                    {/*
                                    <ConsorcioSimulacaoInputList
                                        label={LABEL.pessoaFisicaJuridica}
                                        Componente={ConsorcioSimulacaoPessoaFisicaJuridica}
                                        params={params}
                                    />
                                    */}

                                    <ConsorcioSimulacaoReport
                                        label={LABEL.valorCreditoConsorcio}
                                        valor={item.valorCreditoConsorcio}
                                    />

                                    {item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraMAPFRE && (
                                        <ConsorcioSimulacaoReport
                                            label={LABEL.valorUpGradeCreditoConsorcio}
                                            valor={item.valorUpGradeCreditoConsorcio}
                                        />
                                    )}

                                    <ConsorcioSimulacaoReport
                                        label={LABEL.prazoAtualGrupoConsorcio}
                                        numero={item.prazoTotalGrupoConsorcio}
                                    />

                                    {item.prazoOriginalGrupoConsorcio && (
                                        <ConsorcioSimulacaoReport
                                            label={LABEL.prazoOriginalGrupoConsorcio}
                                            numero={item.prazoOriginalGrupoConsorcio}
                                        />
                                    )}

                                    {(item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                    //item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBradesco ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa) && (
                                        <ConsorcioSimulacaoReportNumeroValor
                                            label={LABEL.adesao}
                                            numero={item.parcelasAdesao}
                                            valor={item.valorParcelasAdesao}
                                        />
                                    )}

                                    <ConsorcioSimulacaoReportNumeroValor
                                        label={LABEL.parcelaAteComtemplacao}
                                        numero={item.contemplacaoParcela}
                                        valor={item.valorParcelaInicial}
                                    />

                                    <GridContainer
                                        className='mt-3 mb-3'
                                    >
                                        <GridItem12>
                                            {(item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBradesco ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa) && (
                                                <ConsorcioSimulacaoReport
                                                    label={LABEL.taxaAdesao}
                                                    perc={item.taxaAdesao}
                                                />
                                            )}

                                            {item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraBancorbras &&
                                            item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraBradesco &&
                                            item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraEmbracon &&
                                            item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraPortoSeguro &&
                                            item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraServopa && (
                                                <GridContainer>
                                                    <GridItem12>
                                                        <div
                                                            className='mt-3'
                                                        />
                                                    </GridItem12>
                                                </GridContainer>
                                            )}

                                            <ConsorcioSimulacaoReport
                                                label={LABEL.taxaAdministracao}
                                                perc={
                                                    item.calcularTaxaMensalAnualResumoComBaseCreditoLiberado
                                                        ?
                                                            item.taxaAdministracaoReal
                                                        :
                                                            item.taxaAdministracao
                                                }
                                            />

                                            <ConsorcioSimulacaoReport
                                                label={LABEL.percFundoReserva.replace('% ', '')}
                                                perc={
                                                    item.calcularTaxaMensalAnualResumoComBaseCreditoLiberado
                                                        ?
                                                            item.percFundoReservaReal
                                                        :
                                                            item.percFundoReserva
                                                }
                                            />

                                            {item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraBancorbras &&
                                            item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraBradesco &&
                                            item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraEmbracon &&
                                            item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraPortoSeguro &&
                                            item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraServopa&& (
                                                <GridContainer>
                                                    <GridItem12>
                                                        <div
                                                            className='mt-3'
                                                        />
                                                    </GridItem12>
                                                </GridContainer>
                                            )}

                                            <GridContainer>
                                                <GridItem12
                                                        className='ml-45 mt--25'
                                                    >
                                                    <SvgImageChaveSetaConsorcio
                                                        //fontSize="small"
                                                    />
                                                </GridItem12>

                                                <GridItem12
                                                    className={(report ? 'ml-101' : 'ml-125') +' mt--17'}
                                                >
                                                    <ConsorcioSimulacaoReport
                                                        label={''}
                                                        perc={
                                                            item.calcularTaxaMensalAnualResumoComBaseCreditoLiberado
                                                                ?
                                                                    item.taxaTotalReal
                                                                :
                                                                    item.taxaTotal
                                                        }
                                                    />
                                                </GridItem12>

                                                <GridItem12
                                                    className={(report ? 'ml-135' : 'ml-165') +' mt--21'}
                                                >
                                                    <ConsorcioSimulacaoReport
                                                        label={LABEL.taxaEfetivaMensal}
                                                        perc={
                                                            item.calcularTaxaMensalAnualResumoComBaseCreditoLiberado
                                                                ?
                                                                    item.taxaEfetivaMensalReal
                                                                :
                                                                    item.taxaEfetivaMensal
                                                        }
                                                    />
                                                    <ConsorcioSimulacaoReport
                                                        label={LABEL.taxaEfetivaAnual}
                                                        perc={
                                                            item.calcularTaxaMensalAnualResumoComBaseCreditoLiberado
                                                                ?
                                                                    item.taxaEfetivaAnualReal
                                                                :
                                                                    item.taxaEfetivaAnual
                                                        }
                                                    />
                                                </GridItem12>
                                            </GridContainer>

                                            {(item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraAdemicon ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraAncora ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBradesco ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraCNP ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraItau ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRacon ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRodobens ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraSantander ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraUne ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraXP) &&
                                            item.percRedutorParcela && (
                                                <GridContainer
                                                    className='mt-3'
                                                >
                                                    <GridItem12>
                                                        <ConsorcioSimulacaoReport
                                                            label={LABEL.percRedutorParcela.replace('% ', '')}
                                                            perc={item.percRedutorParcela}
                                                        />
                                                    </GridItem12>
                                                </GridContainer>
                                            )}
                                        </GridItem12>
                                    </GridContainer>
                                </GridItem12>
                            </GridContainer>
                        </CardGridEstudoHeaderBody>
                            
                        <CardGridEstudoHeaderBody
                            title={LABEL.estrategiaLance}
                        >
                            <GridContainer>
                                <GridItem12>
                                    <ConsorcioSimulacaoReportPercValor
                                        label={LABEL.lanceRecursosProprios}
                                        perc={item.percLanceRecursosProprios}
                                        valor={item.lanceRecursosProprios}
                                        opcional={true}
                                    />
                                    
                                    {(item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraAdemicon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraAncora ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraCNP ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraItau ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRacon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRodobens ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraSantander ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraUne ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraXP) && (
                                        <ConsorcioSimulacaoReportPercValor
                                            label={LABEL.lanceEmbutido}
                                            perc={item.percLanceEmbutido}
                                            valor={item.lanceEmbutido}
                                            opcional={true}
                                        />
                                    )}

                                    {item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraMAPFRE && (
                                        <>
                                            <ConsorcioSimulacaoReportPercValor
                                                label={LABEL.lanceIntegrado}
                                                perc={item.percLanceIntegrado}
                                                valor={item.lanceIntegrado}
                                                opcional={true}
                                            />

                                            <ConsorcioSimulacaoReportPercValor
                                                label={
                                                    pesquisaDescricaoList(linhaInstituicaoFinanceira.tipoLanceList, item.tipoLance)
                                                }
                                                perc={item.percTipoLanceValor}
                                                valor={item.tipoLanceValor}
                                                opcional={true}
                                            />

                                            <ConsorcioSimulacaoReportPercValor
                                                label={LABEL.formaAbaterLance}
                                                texto={
                                                    pesquisaDescricaoList(formaAbaterLanceList, item.formaAbaterLance)
                                                }
                                                opcional={true}
                                            />
                                        </>
                                    )}
                                </GridItem12>
                            </GridContainer>
                        </CardGridEstudoHeaderBody>
                    </GridItem12>
                </GridContainer>
            </GridItem12>
            
            <GridItem12>
                <GridContainer
                    className='justify-center'
                >
                    <GridItem12>
                        {/*
                        <CardGridEntradaDadosConsorcioSimulacaoItem
                            className={classNameCardGridEntradaDadosConsorcioSimulacaoItem1}
                        >
                            <CardGridEstudoHeaderBody
                                title={LABEL.taxasGrupo}
                            >
                                {item.pessoaFisicaJuridica !== HARDCODE.idPessoaJuridica && (
                                    <ConsorcioSimulacaoInputPerc
                                        label={LABEL.percSeguroPrestamista.replace('% ', '')}
                                        Componente={ConsorcioSimulacaoPercSeguroPrestamista}
                                        params={params}
                                        valor={item.valorSeguroPrestamista}
                                    />
                                )}

                                {(item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa) && (
                                    <ConsorcioSimulacaoExibeValor
                                        label={LABEL.valorParcelaInicialSemRedutor}
                                        params={params}
                                        valor={item.valorParcelaInicialSemRedutor}
                                    />
                                )}

                                {(item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa) && (
                                    <ConsorcioSimulacaoExibeValor
                                        label={LABEL.valorEconomiaRedutorParcela}
                                        params={params}
                                        valor={item.valorEconomiaRedutorParcela}
                                    />
                                )}
                            </CardGridEstudoHeaderBody>
                        </CardGridEntradaDadosConsorcioSimulacaoItem>
                        )*/}

                        <CardGridEstudoHeaderBody
                            title={LABEL.estimativaPosContemplacao}
                        >
                            <GridContainer>
                                <GridItem12>
                                    {item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraMAPFRE && (
                                        <ConsorcioSimulacaoReport
                                            label={LABEL.parcelasTCV}
                                            numero={item.parcelasTCV}
                                            opcional={true}
                                        />
                                    )}

                                    <ConsorcioSimulacaoReportNumeroValor
                                        label={LABEL.parcelaAposComtemplacao}
                                        numero={item.prazoRestanteAposContemplacao}
                                        valor={item.valorParcelaAposComtemplacao}
                                    />

                                    {(//item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa) && (
                                        <ConsorcioSimulacaoReportNumeroValor
                                            label={LABEL.parcelaAposComtemplacaoReducaoPrazo}
                                            numero={item.prazoRestanteAposContemplacaoReducaoPrazo}
                                            valor={item.parcelaAposComtemplacaoReducaoPrazo}
                                        />
                                    )}
                                    
                                    <ConsorcioSimulacaoReport
                                        label={LABEL.creditoDisponivel}
                                        valor={item.valorCreditoDisponivel}
                                    />
                                    
                                    {item.valorCreditoConsorcioContemplacao && (
                                        <ConsorcioSimulacaoReport
                                            label={LABEL.valorCreditoConsorcioContemplacao.replace('$1$',
                                                item.taxaAnualReajusteConsorcio)}
                                            valor={item.valorCreditoConsorcioContemplacao}
                                        />
                                    )}
                                </GridItem12>
                            </GridContainer>
                        </CardGridEstudoHeaderBody>
                    </GridItem12>
                </GridContainer>
            </GridItem12>

            {report && (
                <GridContainer
                    className='mt-10'
                >
                    <GridItem12>
                        {formataNotaConsorcio(MESSAGE().notaConsorcio)}
                    </GridItem12>
                </GridContainer>
            )}
        </GridContainer>
    )
}

export default ConsorcioFormSimulacaoItemReport